// extracted by mini-css-extract-plugin
export default {"App":"styles_App__YbTQN","details":"styles_details__YKLaR","topnav":"styles_topnav__s-H3F","input-group":"styles_input-group__D8Utz"};